/**
 * This function determines if a video track is a screenshare track or not
 * @param videoTrack A Twilio video
 * @return A true or false boolean
 */

import { RemoteVideoTrackPublication, LocalVideoTrackPublication } from 'twilio-video'

export default function (videoTrack: LocalVideoTrackPublication | RemoteVideoTrackPublication): boolean {

  if (!videoTrack.trackName) return false

  return videoTrack.trackName.match(/-screen-/) !== null

}
